import { Checkbox, FormControlLabel, FormGroup, FormLabel, MenuItem, Select, Stack, TextField } from "@mui/material"
import { CategoryData, TemplateData } from "../../../types";

interface CategorySelectOptionProps {
  item: any;
  depth: number;
}

const CategorySelectOption = ({ item, depth }: CategorySelectOptionProps) => {
  const prespace = [];
  for (let i=0; i<depth; i++) prespace.push(i);
  if (item?.children?.length) {
    return (
      <>
        <option value={item?.id}>
          {
            prespace.map(() => <>&nbsp;&nbsp;&nbsp;&nbsp;</>)
          }
          {item?.name}
        </option>
        {
          item?.children?.map((child: any, index: number) => (
            <CategorySelectOption key={index} item={child} depth={depth + 1} />
          ))
        }
      </>
    )
  } else {
    return (
      <option value={item?.id}>
        {
          prespace.map((index) => <>&nbsp;&nbsp;&nbsp;&nbsp;</>)
        }
        {item?.name}
      </option>
    )
  }
}

interface TargetingBoxProps {
  template: TemplateData;
  setTemplate: (val: TemplateData) => void;
  categories: CategoryData[],
}

export const TargetingBox = ({ template, categories, setTemplate }: TargetingBoxProps) => {
  return (
    <Stack spacing={4}>
      <FormGroup>
        <FormControlLabel
          label="Send on birthday"
          control={
            <Checkbox
              checked={template.targeting?.send_on_birthday} 
              onChange={(e: any) => setTemplate({ ...template, targeting: { ...template.targeting ?? {}, send_on_birthday: e.target.checked } })}
            />
          }
        />
      </FormGroup>
      <FormGroup>
        <Stack>
          <FormLabel>Interaction Number</FormLabel>
          <TextField
            variant="outlined"
            type="number"
            sx={{ width: '340px' }}
            value={template.targeting?.interaction_number} 
            onChange={(e: any) => setTemplate({ ...template, targeting: { ...template.targeting ?? {}, interaction_number: e.target.value } })}
          />
        </Stack>
      </FormGroup>
      <FormGroup>
        <Stack>
          <FormLabel>Interactions</FormLabel>
          <FormControlLabel
            label="Has interacted with similar products"
            control={
              <Checkbox
                checked={template.targeting?.interacted_with_same_products} 
                onChange={(e: any) => {
                  setTemplate({ 
                    ...template, 
                    targeting: { 
                      ...template.targeting ?? {}, 
                      interacted_with: e.target.checked ? template.targeting?.interacted_with : '', 
                      interacted_with_same_products: e.target.checked 
                    }
                  })
                }}
              />
            }
          />
        </Stack>
      </FormGroup>
      <FormGroup>
        <FormLabel>Interacted width</FormLabel>
        <Select 
          native
          variant="outlined"
          value={template.targeting?.interacted_with ?? ''}
          disabled={!template.targeting?.interacted_with_same_products}
          onChange={(e: any) => {
            setTemplate({ 
              ...template, 
              targeting: { ...template.targeting ?? {}, interacted_with: e.target.value } 
            })
          }}
          sx={{ width: '340px' }}
        >
          <option></option>
          {
            categories.map((item: any, index: number) => (
              <CategorySelectOption key={index} item={item} depth={0} />
            ))
          }
        </Select>
      </FormGroup>
    </Stack>
  )
}